<header class="fixed top-0 left-0 right-0 z-50 text-white">
  <div
    class="relative bg-black/25 backdrop-blur-lg shadow-neumorphic-dark border-b-2 border-white/5"
  >
    <div
      class="absolute inset-0 bg-amethyst-dark opacity-90 -z-10 bg-[length:400%_400%] animate-gradient"
    ></div>
    @if (vm$ | async; as vm) {
      <div
        class="max-w-7xl mx-auto flex items-center justify-between px-4 py-3 h-16"
      >
        <!-- Logo -->
        <a routerLink="/" class="flex items-center space-x-2">
          <img src="assets/logo.png" alt="Altair Parfum Logo" class="h-10 w-auto object-contain drop-shadow-md" />
        </a>
        <!-- Navigation Icons -->
        <nav class="flex items-center space-x-2">
          <!-- Search Icon -->
          <button
            (click)="toggleSearch()"
            appGalaxyButton
            galaxyVariant="ghost"
            class="!rounded-full !w-10 !h-10 !p-0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </button>
          <!-- Botón de Soporte WhatsApp -->
          <button
            (click)="openSupportChat()"
            appGalaxyButton
            galaxyVariant="ghost"
            class="!rounded-full !w-10 !h-10 !p-0"
            title="Soporte por WhatsApp"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.894 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01s-.521.074-.792.372c-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
              ></path>
            </svg>
          </button>
          <!-- Cart Icon -->
          <a routerLink="/cart/sumary" class="relative p-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>
            @if (vm.cartQuantity > 0) {
              <span
                class="absolute top-0 right-0 bg-champagne-gold text-obsidian font-bold text-xs rounded-full h-5 w-5 flex items-center justify-center shadow-gold-glow"
              >
                {{ vm.cartQuantity }}
              </span>
            }
          </a>
          <!-- Logout Button -->
          @if (vm.isLoggedIn) {
            <button
              (click)="logout()"
              appGalaxyButton
              galaxyVariant="ghost"
              class="!rounded-full !w-10 !h-10 !p-0 text-red-400/80 hover:text-red-400"
            >
              <svg
                class="h-6 w-6"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                <polyline points="16 17 21 12 16 7"></polyline>
                <line x1="21" y1="12" x2="9" y2="12"></line>
              </svg>
            </button>
          }
        </nav>
      </div>
    }

    <!-- Search Bar (Toggles) -->
    @if (isSearchVisible) {
      <div class="p-4">
        <form (ngSubmit)="onSearch()" class="flex items-center space-x-2">
          <input
            name="search"
            [(ngModel)]="searchQuery"
            type="text"
            placeholder="Buscar productos..."
            class="glass-input !py-2"
          />
          <button
            type="submit"
            appGalaxyButton
            galaxyVariant="primary"
            class="!py-2"
          >
            Buscar
          </button>
        </form>
      </div>
    }
  </div>
</header>
